import Vue from 'vue'
import { ToastPlugin, ModalPlugin, VBTooltip } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/axios'
import '@/libs/vue-select'
import '@/libs/clipboard'
import '@/libs/acl'

moment.locale('de')
flatpickr.localize(German)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
require('@core/scss/vue/libs/vue-good-table.scss')
require('@core/scss/vue/libs/vue-select.scss')
require('@core/assets/fonts/feather/iconfont.css')

Vue.config.productionTip = false
Vue.directive('ripple', Ripple)
Vue.directive('b-tooltip', VBTooltip)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
